import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";

import ApiServer from "../ApiServer.js";
import { SimpleControllerBook } from "../page/ControllerBook.js";

import Icons from "../svg/Icons.ts";
import {clear as clearSelection, selection} from "../widget/media-selector.js"
import { GalleryListCache, GalleryCache } from "./GalleryBeans.js";
import { registerFileDropConsumer, pickFileFromDevice } from "../lib/FileUtils.ts";
import { uploadMultiplePictures } from "../widget/form/input-images.js";
import { ExecutorES6 } from "../lib/ExecutorES6.js";
import $ from "../$.js";
import * as  i18n from "../i18n.ts";
import {template_gallery, template_gallery_content} from "./template_gallery.ts"

var ImageLoaderExecutor = new ExecutorES6(5);

function isNodeInScreen(node){
  var rect = node.getBoundingClientRect();
  if(rect.bottom<0) return false;
  if(rect.right<0) return false;
  if(rect.top>window.innerHeight) return false;
  if(rect.left>window.innerWidth) return false;
  return true;
}

function loadImageWithDataSrc(domNode){
  ImageLoaderExecutor.clearQueue()
  var allVisibleNode = Array.from(domNode.querySelectorAll('*[data-src]')).filter(isNodeInScreen);

  allVisibleNode.forEach(img=>{
    ImageLoaderExecutor.push(()=>{
      //we recheck
      if(!isNodeInScreen(img)) return;
      
      return new Promise((resolve,reject)=>{
        var src = img.getAttribute('data-src');
        if(src===null){
          resolve(img)
          return;
        }
        img.removeAttribute('data-src');
        if(img.getTagName!=='IMG'){
          img.style.backgroundImage = `url(${src})`
          img = document.createElement('img');
        }
        img.onload = resolve;
        img.onerror = reject;
        img.setAttribute('src',src)
            
      })
    })
    
  })
}

INR.onPage(INR.URL.GALLERY,function(){
  
  var   
    leftNode = $('.pane-left'),
    rightNode = $('.pane-main'),
    leftUpdater = (items)=>{
      Html.setHtml(leftNode,template_gallery,{
        all:items.find(item=>item.metaId==='albumCover/ALL'),
        favorites:items.find(item=>item.metaId==='albumCover/MOOD_STAR'),
        members:items.filter(item=>item.accountId!==null)
      })
    },
    rightUpdater = async (ID)=>{
      clearSelection()
      
      var 
        [albums,medias] = await Promise.all([GalleryListCache.need(),GalleryCache.need()]),
        head = GalleryListCache.get(ID)||albums[0];
      
      Html.setHtml(rightNode,template_gallery_content,{
        head,
        content:medias.mediaList.datas.filter(head.getMediaFilter()),
        emptyState:{
          img:head.type==="MOOD_STAR"?'images/empty_state_illustration_gallery_favorites.svg':'images/empty_state_illustration_gallery.svg',
          title:{"ALL":'photos.emptytitleall',"MOOD_STAR":'photos.emptytitlefavorite',"AUTHOR":'photos.emptytitleaccount'}[head.type],
          text:{"ALL":'photos.emptytextall',"MOOD_STAR":'photos.emptytextfavorite',"AUTHOR":'photos.emptytextaccount'}[head.type],
          name:head.type==="AUTHOR"?head.account.firstName:undefined
        }
      })
      //in mobile view the right pane display later, so we need to wait a little
      setTimeout(function(){
        loadImageWithDataSrc(rightNode.get(0))
      },10)
      rightNode.find('.flexauto').on('scroll resize',(evt)=>{
        loadImageWithDataSrc(rightNode.get(0))
      }) 
      
    },
    CONTROLLER = new SimpleControllerBook(leftNode,leftUpdater,GalleryListCache,rightNode,rightUpdater)
  
    //TODO move that in a specific file for reuse
    //and add also an Html listener, and use this everywhere
    
    
    
    
    
  amplify.publish("handleParam");
  INR.subscribe('newActivity',function(){
    GalleryCache.refresh()
    CONTROLLER.refresh()
  })

});

registerFileDropConsumer(function(){
  return {
    nodes:document.querySelectorAll('.gallery-album'),
    ondrop(event){
      uploadMultiplePictures(event.dataTransfer.files)
    }
  }
})

actionMenu.register({
  async gallerymenu(){
    var 
      album = (await GalleryListCache.get(this.metaId())),
      medias = (await GalleryCache.need()).mediaList.datas.filter(album.getMediaFilter()),
      buttons = [
        {svg:Icons.ic_add_image,onclick:"galleryadd",i18nkey:'actions.addphotos',disabled:!album.canAdd},
        ,
        ];
    if(selection.size()>0){
      buttons.push(
        {svg:Icons.ic_download,onclick:"selectiondownload",title:i18n.get('actions.downloadN',selection.size())},
        {svg:Icons.ic_delete,onclick:"selectiondelete",title:i18n.get('actions.deleteN',selection.size()),color:"var(--red)"}
      )
    }else{
      
      buttons.push(
        {svg:Icons.ic_download,onclick:"mediadownload",i18nkey:'actions.download',disabled:medias.length===0},
        {svg:Icons.ic_delete,onclick:"gallerydelete",i18nkey:'actions.delete',color:"var(--red)",disabled:medias.length===0}
      )
    }
    
    return {'menu':buttons}
  }
})

Html.register({
  async galleryadd(){
    var 
      accept = (FwDatas.getPermission('videoAvailable')==='OK')?"image/*,video/*":"image/*",
      files = await pickFileFromDevice(accept,true)
    if(files.length>0){
      uploadMultiplePictures(files)
    }
  },
  async gallerydelete(){
    var 
      album = GalleryListCache.get(this.metaId()),
      medias = (await GalleryCache.need()).mediaList.datas.filter(album.getMediaFilter()),
      mediasAllowed = medias.filter(media=>media.rights.canDelete),
      isAdmin = medias.length===mediasAllowed.length;
    
    if(isAdmin){
      modal.confirmDelete({
        title:"photos.confirmdeletetitleadmin",
        message:'photos.confirmdeletealbumadmin',
        yes:'actions.deleteeverything',
        no:"actions.cancel"
      },async ()=>{  
        await ApiServer.metadelete.setOptions({timeout:10000+mediasAllowed.length*1000})(mediasAllowed.map(media=>media.metaId))
        modal.toastDone('photos.toastdeleted',mediasAllowed.length)
        amplify.publish("newActivity")
      })
    }else{
      modal.confirmDelete({
        title:"photos.confirmdeletetitle",
        message:'photos.confirmdeletenotadmin',
        no:"actions.cancel"
      },async ()=>{  
        await ApiServer.metadelete.setOptions({timeout:10000+mediasAllowed.length*1000})(mediasAllowed.map(media=>media.metaId))
        modal.toastDone('photos.toastdeleted',mediasAllowed.length)
        amplify.publish("newActivity")
      })
    }  
    
  }
})

